export enum ClientMaritalStatusEnum {
    Single = "OWNER_MARITAL_STATUS_SINGLE",
    Married = "OWNER_MARITAL_STATUS_MARRIED",
    Other = "OWNER_MARITAL_STATUS_OTHER",
}